const pixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1;

const getPixelRatio = (dimension: number): number => {
  return Math.round(pixelRatio * dimension);
};

export default getPixelRatio;
